import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type FormValues } from "../useSendShieldedForm";

import { useColor } from "@/styles/useColor";

type AmountFieldProps = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  symbol: string;
  validateAmount: (value: string) => true | string;
  isDisabled?: boolean;
};

export const AmountField = ({
  register,
  errors,
  symbol,
  validateAmount,
  isDisabled,
}: AmountFieldProps) => {
  const color = useColor();

  return (
    <FormControl isInvalid={!!errors.amount}>
      <FormLabel>Amount</FormLabel>
      <InputGroup>
        <Input
          isDisabled={isDisabled}
          step="0.000001"
          type="number"
          {...register("amount", {
            required: "Amount is required",
            validate: validateAmount,
          })}
          placeholder="0.000000"
        />
        <InputRightElement marginRight="16px" color={color("400")} fontSize="16px">
          {symbol}
        </InputRightElement>
      </InputGroup>
      {errors.amount && (
        <FormErrorMessage data-testid="amount-error">{errors.amount.message}</FormErrorMessage>
      )}
    </FormControl>
  );
};
